var map = {
	"./asset-hyperlink.json": 82282,
	"./blockquote.json": 19785,
	"./document.json": 76334,
	"./embedded-asset-block.json": 67831,
	"./embedded-entry-block.json": 35098,
	"./embedded-entry-inline.json": 56037,
	"./embedded-resource-block.json": 16037,
	"./embedded-resource-inline.json": 73671,
	"./entry-hyperlink.json": 59151,
	"./heading-1.json": 20052,
	"./heading-2.json": 82694,
	"./heading-3.json": 45801,
	"./heading-4.json": 62060,
	"./heading-5.json": 30968,
	"./heading-6.json": 48458,
	"./hr.json": 10524,
	"./hyperlink.json": 13471,
	"./list-item.json": 49097,
	"./ordered-list.json": 58293,
	"./paragraph.json": 59932,
	"./resource-hyperlink.json": 85576,
	"./table-cell.json": 40201,
	"./table-header-cell.json": 44022,
	"./table-row.json": 54221,
	"./table.json": 57997,
	"./text.json": 24714,
	"./unordered-list.json": 67130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69128;